(function() {
  const onHamburger = function(event) {
    const target = document.querySelector('[data-js-hamburger]')
    target.classList.toggle('hamburger--active')
    const activator = document.querySelector('[data-js="hamburger"]')
    activator.classList.toggle('hamburger--active')

    // search focus
    // TODO maybe not great to do focus on mobile
    const input = target.querySelector('input')
    if (input && target.classList.contains('hamburger--active')) {
      input.focus()
    }
  }

  const onClick = function (event) {
    const js = event.target.dataset.js || event.target.parentElement.dataset.js
    switch (js) {
      case 'hamburger':
        return onHamburger(event)
      default:
    }
  }

  const OnEnter = function(event) {
    const targetId = event.target.dataset.jsDrawer
    const target = document.querySelector(`[data-js-drawer-target="${targetId}"]`)
    const style = window.getComputedStyle(target)
    if (style.display === 'none') {
      console.info('Skipping hidden drawer')
      return
    }

    const otherTargets = document.querySelectorAll('.header__drawer--active')
    for (const otherTarget of otherTargets) {
      otherTarget.classList.remove('header__drawer--active')
    }

    target.classList.add('header__drawer--active')
    // search focus
    const input = target.querySelector('input')
    if (input) {
      input.focus()
    }
  }

  const onLeave = function(event) {
    const otherTargets = document.querySelectorAll('.header__drawer--active')
    for (const otherTarget of otherTargets) {
      otherTarget.classList.remove('header__drawer--active')
    }
  }

  const setupDrawers = function() {
    const drawers = document.querySelectorAll('[data-js="drawer"]')
    for (const element of drawers) {
      // TODO only add if the target is not hidden
      // const targetId = element.dataset.jsDrawer
      // const target = document.querySelector(`[data-js-drawer-target="${targetId}"]`)
      // const style = window.getComputedStyle(target)
      // // hidden drawers are marked for ignore
      // if (style.display !== 'none') {
      //   element.addEventListener('mouseenter', OnEnter)
      // }

      element.addEventListener('mouseenter', OnEnter)
    }

    const drawerTargets = document.querySelectorAll('[data-js-drawer-target]')
    for (const element of drawerTargets) {
      element.addEventListener('mouseleave', onLeave)
    }
  }

  const carouselScrolls = new Map()
  const onCarouselWheel = function(evt) {
    const carousel = evt.target.closest('[data-js="carousel"]')
    const card = carousel.querySelector('.card, .author-card')
    const style = window.getComputedStyle(card)
    const maxScrollLeft = Math.round(carousel.scrollWidth - carousel.clientWidth)
    const direction = (evt.detail < 0 || evt.wheelDelta > 0) ? 1 : -1

    const carouselData = carouselScrolls.get(carousel)
    // const chunk = Math.sign(evt.deltaY) * (parseInt(style.width) + parseInt(style.marginRight))
    const chunk = direction * (parseInt(style.width) + parseInt(style.marginRight))
    // carouselScrollLeft += Math.sign(evt.deltaY) * (parseInt(style.width) + parseInt(style.marginRight))
    // carouselScrollLeft += evt.deltaY
    // carouselScrollLeft += (Math.ceil(evt.deltaY / chunk) * chunk)
    carouselData.carouselScrollLeft += evt.deltaY
    // console.log('chunks', Math.ceil((Math.ceil(evt.deltaY / chunk) * chunk) / 2))
    carouselScrolls.set(carousel, carouselData)

    carousel.scrollLeft = carouselData.carouselScrollLeft
    // carousel.scrollLeft += evt.deltaY
    // carousel.scrollBy(Math.sign(evt.deltaY) * (parseInt(style.width) + parseInt(style.marginRight)) + evt.deltaY, 0)
    const scrollLeft = Math.round(carousel.scrollLeft)

    if ((Math.sign(evt.deltaY) === -1 && scrollLeft > 0) || (Math.sign(evt.deltaY) === 1 && scrollLeft < maxScrollLeft)) {
      evt.preventDefault()
      evt.stopPropagation()
    } else {
      carouselData.carouselScrollLeft = scrollLeft
      carouselScrolls.set(carousel, carouselData)
    }

    // done!
    return false
  }

  const onMouseenterCarousel = function(event) {
    let carouselData = carouselScrolls.get(event.target)
    if (!carouselData) {
      carouselData = { carouselScrollLeft: 0 }
    }

    window.clearTimeout(carouselData.timer)
    carouselData.timer = window.setTimeout(() => {
      event.target.addEventListener('wheel', onCarouselWheel)
    }, 2000)

    carouselScrolls.set(event.target, carouselData)
  }

  const onMouseleaveCarousel = function(event) {
    let carouselData = carouselScrolls.get(event.target)
    if (!carouselData) {
      carouselData = { carouselScrollLeft: 0 }
    }

    window.clearTimeout(carouselData.timer)
    carouselData.timer = null
    event.target.removeEventListener('wheel', onCarouselWheel)

    carouselScrolls.set(event.target, carouselData)
  }

  let carouselScrollLeft = 0
  const setupCarousels = function() {
    if (window.innerWidth < 768) {
      console.warn('Skipping carousel bootstrapping, mobile')
      return
    }

    const carousels = document.querySelectorAll('[data-js="carousel"]')
    for (const carousel of carousels) {
      carousel.addEventListener('mouseenter', onMouseenterCarousel)
      carousel.addEventListener('mouseleave', onMouseleaveCarousel)
    }

    console.info('setupCarousels: Carousels ready', carousels.length)
  }

  const swapElements = function(node1, node2) {
    const afterNode2 = node2.nextElementSibling
    const parent = node2.parentNode
    if (node1 === afterNode2) {
      parent.insertBefore(node1, node2)
    } else {
      node1.replaceWith(node2)
      parent.insertBefore(node1, afterNode2)
    }
  }

  const setupRandomize = function () {
    const randoms = document.querySelectorAll('[data-randomize]')
    for (const random of randoms) {
      const randomsSelector = random.dataset.randomize || '*'
      for (let i = random.children.length - 1; i >= 0; i--) {
        const swap1 = random.children[i]
        const swap2 = random.children[Math.random() * i | 0]
        if (swap1.matches(randomsSelector) && swap2.matches(randomsSelector)) {
          swapElements(swap1, swap2)
        }
      }

      random.dataset.randomize = 'done'
    }

    console.info('setupRandomize: Randomized processed', randoms.length)
  }

  const getVimeoVideoId = function (url) {
    const firstPart = url.split('?')[0].split('/')
    const vid = firstPart[firstPart.length - 1]

    return vid
  }

  const getYouTubeVideoId = function (url) {
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
    return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0]
  }

  const setupCardPlaceholderImage = function(element) {
    // bails for featured video posts on the actual post page
    if (!element.classList.contains('card__featured-video-content')) {
      console.info('setupCardPlaceholderImage: Not setting up video placeholder image', element)
      element.classList.add('featured-video--processed')
      const video = document.querySelector('.f-post article.tag-hash-featuredvideo .post__content .kg-card.kg-embed-card:first-child')
      if (video) {
        video.remove()
      }
      // not a card
      return
    }

    // https://i.ytimg.com/vi_webp/XsVJ8PCV-0M/maxresdefault.webp
    const embed = element.querySelector('iframe')
    if (!embed) {
      console.warn('setupCardPlaceholderImage: Whoops, no embed iframe', element)
      element.classList.add('card__featured-video--processed')
      return
    }

    if (embed.src.indexOf('www.youtube.com') >= 0) {
      const videoId = getYouTubeVideoId(embed.src)
      const img = document.createElement('img')
      img.src = `https://i.ytimg.com/vi_webp/${videoId}/maxresdefault.webp`

      if (element.classList.contains('card__featured-video-content')) {
        const destination = element.closest('.card').querySelector('.card__featured-video')
        destination.appendChild(img)
        destination.classList.add('card__featured-video--processed')
        element.remove()
      } else {
        element.innerHTML = ''
        element.appendChild(img)
        element.classList.add('card__featured-video--processed')
      }
    }

    // using async await
    // https://stackoverflow.com/questions/47439067/uglifyjs-throws-unexpected-token-keyword-const-with-node-modules
    // https://stackoverflow.com/questions/33527653/babel-6-regeneratorruntime-is-not-defined?answertab=scoredesc#tab-top

    // No straight Viemo URL a la youtube
    // https://stackoverflow.com/questions/61839510/get-thumbnail-image-of-vimeo-video-without-making-a-request-to-the-vimeo-api
    if (embed.src.indexOf('vimeo.com') >= 0) {
      const videoId = getVimeoVideoId(embed.src)
      // const resp = await fetch(`http://vimeo.com/api/v2/video/${videoId}.json`)
      fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
        .then(response => response.json())
        .then(data => {
          const video = data[0]
          const img = document.createElement('img')
          img.src = video.thumbnail_large
          img.alt = video.title

          if (element.classList.contains('card__featured-video-content')) {
            const destination = element.closest('.card').querySelector('.card__featured-video')
            destination.appendChild(img)
            destination.classList.add('card__featured-video--processed')
            element.remove()
          } else {
            element.innerHTML = ''
            element.appendChild(img)
            element.classList.add('card__featured-video--processed')
          }
        })
    }

    console.warn('setupCardPlaceholderImage: unknown video embed')
  }

  const setupVideoCards = function() {
    const featuredVideos = document.querySelectorAll('.card__featured-video-content, .f-post-hero__featured-video')
    for (const featuredVid of featuredVideos) {
      const toRemove = featuredVid.querySelectorAll(':scope > *:not(.kg-card.kg-embed-card:first-child)')
      toRemove.forEach(element => element.remove())
      setupCardPlaceholderImage(featuredVid)
    }

    console.info('setupVideoCards: Video cards processed', featuredVideos.length)
  }

  const setupNewsAnchorBlocks = function() {
    const newsAnchors = document.querySelectorAll(`
      .card.card--news:not(.card--carousel) .card__image,
      .card.card--news:not(.card--carousel) .card__featured-video,
      .card.card--news:not(.card--carousel) .card__title a
    `)
    for (const newsAnchor of newsAnchors) {
      newsAnchor.removeAttribute('href')
    }

    console.info('setupNewsAnchorBlocks: News anchors processed', newsAnchors.length)
  }

  const adjustOurEventsBox = function() {
    const keyColumn = document.querySelector('.home__landing .home__landing__col:first-child')
    const featuredCard = document.querySelector('.home__landing__col:last-child .card')
    const upcomingEvents = document.querySelector('.home__landing__col:last-child .upcoming-events')

    if (!keyColumn) {
      console.warn('adjustOurEventsBox: No key column')
      return
    }

    const existingStyle = getComputedStyle(upcomingEvents)
    upcomingEvents.style.display = 'none'
    const newMaxheight = keyColumn.clientHeight - featuredCard.clientHeight
    upcomingEvents.style.maxHeight = `${newMaxheight + 16}px`

    upcomingEvents.style.display = 'block'

    console.info('adjustOurEventsBox: Upcoming events box height adjusted')
  }

  const setupPostHeaderInversion = function() {
    // const post = document.querySelector('.post-template')
    // if (!post) {
    //   console.warn('setupPostHeaderInversion: not a post')
    //   return
    // }

    const header = document.querySelector('header.header')
    document.addEventListener('scroll', function(event) {
      if (window.scrollY > header.clientHeight) {
        header.classList.add('header--inverted')
      } else {
        header.classList.remove('header--inverted')
      }
    })

    console.info('setupPostHeaderInversion: header will invert on scroll')
  }

  const onLoad = function() {
    document.addEventListener('click', onClick)
    setupDrawers()
    // setupCarousels()
    setupRandomize()
    setupVideoCards()
    setupNewsAnchorBlocks()
    adjustOurEventsBox()
    setupPostHeaderInversion()
  }

  document.addEventListener('DOMContentLoaded', onLoad)
}())